var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: false, "label-position": "top" },
              model: {
                value: _vm.queryForm,
                callback: function ($$v) {
                  _vm.queryForm = $$v
                },
                expression: "queryForm",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { size: "small" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selectClass",
                                  style: _vm.IsWidth,
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "orderDetails.pleaseChoose"
                                    ),
                                    size: "small",
                                  },
                                  on: { change: _vm.handleChangeLable },
                                  model: {
                                    value:
                                      _vm.queryForm.params.searchNumberType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "searchNumberType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.searchNumberType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t(
                                        "orderCenterCont.anjunWaybillNumber"
                                      ),
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "8",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.ScanNumber"),
                                      value: "8",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "15",
                                    attrs: {
                                      label: _vm.$t(
                                        "GlobalSetObj.anJunOrderNumber"
                                      ),
                                      value: "15",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t(
                                        "newOrder.PlatformOrderNumber"
                                      ),
                                      value: "2",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "4",
                                    attrs: {
                                      label: _vm.$t(
                                        "orderCenterCont.TransitBinBagNumber"
                                      ),
                                      value: "4",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "7",
                                    attrs: {
                                      label: _vm.$t(
                                        "orderCenterCont.SubpackageNumber"
                                      ),
                                      value: "7",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { "margin-top": "3px" },
                            attrs: {
                              placeholder: _vm.$t("newOrder.PreciseSearch1"),
                              rows: 2,
                              type: "textarea",
                            },
                            model: {
                              value: _vm.searchNumberStr,
                              callback: function ($$v) {
                                _vm.searchNumberStr = $$v
                              },
                              expression: "searchNumberStr",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "searchTimeType", size: "small" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selectClass",
                                  style: _vm.IsWidthTime,
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.params.searchTimeType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "searchTimeType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.searchTimeType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("newOrder.createTime"),
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "5",
                                    attrs: {
                                      label: _vm.$t(
                                        "orderCenterCont.customerDeliveryTime"
                                      ),
                                      value: "5",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "3",
                                    attrs: {
                                      label: _vm.$t(
                                        "newOrder.TransitInboundTime"
                                      ),
                                      value: "3",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "4",
                                    attrs: {
                                      label: _vm.$t("newOrder.shipmentTime"),
                                      value: "4",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "7",
                                    attrs: {
                                      label: _vm.$t(
                                        "orderCenterCont.deliveryTime"
                                      ),
                                      value: "7",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t(
                                        "orderCenterCont.SigningTime"
                                      ),
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%", "margin-top": "3px" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              format:
                                _vm.$i18n.locale === "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              "picker-options": _vm.pickerOptions,
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "range-separator": "~",
                              size: "small",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: {
                              change: _vm.handleTime,
                              input: function ($event) {
                                return _vm.changeInput($event)
                              },
                            },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("newOrder.CustomerName") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.OnlyAreDisplayed"
                                ),
                                "remote-method": _vm.getCustomerPage,
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                remote: "",
                                "reserve-keyword": "",
                                size: "small",
                              },
                              on: {
                                clear: function ($event) {
                                  return _vm.getCustomerPage("")
                                },
                                focus: _vm.getCustomerPageFuc,
                              },
                              model: {
                                value: _vm.queryForm.params.customerIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerIds",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.customerIds",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    "(" +
                                    item.username +
                                    ")",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "28px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.searchFun },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { size: "small", type: "info" },
                            on: { click: _vm.resetForm },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("customerManagements.reset")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t(
                                "orderCenterCont.customizingDisplayColumns"
                              ),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("el-button", {
                              staticStyle: {
                                "font-size": "24px",
                                color: "#333",
                              },
                              attrs: { icon: "el-icon-setting", type: "text" },
                              on: { click: _vm.operationTableDialog },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-dropdown",
            { attrs: { size: "small", trigger: "click" } },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v(_vm._s(_vm.$t("navbar.export"))),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-bottom": "2px" },
                          attrs: { size: "small", type: "success" },
                          on: { click: _vm.allExportOrder },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.allExport")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-bottom": "2px" },
                          attrs: { size: "small", type: "success" },
                          on: { click: _vm.exportOrder },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.export1")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-bottom": "2px" },
                          attrs: { size: "small", type: "success" },
                          on: { click: _vm.orderNumberExport },
                        },
                        [_vm._v(_vm._s(_vm.$t("placeOrder.BatchExport")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "success" },
                          on: { click: _vm.exportOrderChilder },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("collectionCenter.exportChilderInfor")
                            ) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-radio-group",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { size: "small" },
              model: {
                value: _vm.dataType,
                callback: function ($$v) {
                  _vm.dataType = $$v
                },
                expression: "dataType",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: 1 } }, [
                _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
              ]),
              _c("el-radio-button", { attrs: { label: 2 } }, [
                _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
              ]),
            ],
            1
          ),
          _c("el-divider"),
          [
            _c("AnjunTableList", {
              ref: "anjunTable",
              staticClass: "table_color_class",
              attrs: {
                "format-time": _vm.isTormat,
                "has-operation": true,
                "header-list": _vm.tableHeaderList,
                hide: false,
                "is-index": true,
                "is-select-btn": true,
                "is-tip": true,
                "table-data": _vm.tableData,
              },
              on: {
                "on-checkTrajectory": _vm.trajectoryQuery,
                selectTable: _vm.selectTable,
              },
              scopedSlots: _vm._u([
                {
                  key: "waybillNumber",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "top",
                            "popper-class": "copy",
                            trigger: "hover",
                          },
                        },
                        [
                          row.waybillNumber
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    color: "black",
                                    "font-size": "12px",
                                    padding: "2px",
                                  },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copy(row.waybillNumber)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("orderDetails.copy")) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "waybill-number-link",
                              attrs: { slot: "reference" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleClick(row)
                                },
                              },
                              slot: "reference",
                            },
                            [
                              _vm._v(
                                " " + _vm._s(row.waybillNumber || "- -") + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          _c("el-pagination", {
            staticStyle: { margin: "20px 0", "text-align": "right" },
            attrs: {
              "current-page": _vm.queryForm.number,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 50, 100, 200, 400],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "number", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "number", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("seller.customTableDisplayList"),
            visible: _vm.isoperationTable,
            width: "" + (_vm.$i18n.locale === "zh" ? "30%" : "45%"),
          },
          on: {
            "update:visible": function ($event) {
              _vm.isoperationTable = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "tableHeaderForm",
              attrs: { model: _vm.tableHeaderForm, "label-width": "auto" },
            },
            [
              _c("el-form-item", { attrs: { label: "" } }, [
                _c("div", { staticStyle: { "font-size": "18px" } }, [
                  _vm._v(_vm._s(_vm.$t("GlobalSetObj.HideTheColumn"))),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.tableHeaderForm.tableHeaderList,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableHeaderForm, "tableHeaderList", $$v)
                        },
                        expression: "tableHeaderForm.tableHeaderList",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { display: "flex", "flex-flow": "wrap" },
                          attrs: { gutter: 0 },
                        },
                        _vm._l(_vm.bindTableColumns, function (item) {
                          return _c(
                            "el-col",
                            { key: item.id, attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "140px",
                                    "word-wrap": "break-word",
                                    "word-break": "break-all",
                                  },
                                },
                                [
                                  _c("el-checkbox", {
                                    attrs: { label: item.label },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { float: "left" },
                  on: { click: _vm.resetTable },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.reset")) + " ")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isoperationTable = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.operationTable },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("orderNumberExport", { ref: "OrderExport" }),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("orderCenterCont.archivedOrders"),
            visible: _vm.waybillVisible,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.waybillVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "calc(100vh - 67px)", overflow: "auto" } },
            [
              _c("waybill-archived", {
                key: _vm.showQueryTrack.trackKey,
                attrs: {
                  "query-track-param": _vm.TrackParam,
                  "query-type": "1",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("orderCenterCont.TrajectoryQuery"),
            visible: _vm.showQueryTrack.visible,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.showQueryTrack, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "calc(100vh - 67px)", overflow: "auto" } },
            [
              _c("trackQuery", {
                key: _vm.showQueryTrack.trackKey,
                attrs: {
                  "query-track-param": _vm.queryTrackParam,
                  "query-type": "1",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }